<template>
<v-footer padless :style="isLogIn ? `background: #6cc5e4;` : `background: #6cc5e4; background-image: url('https://trackier.com/images/angle-bg.png'); background-position: left;`">
    <v-row justify="center" no-gutters>
        <v-col v-if="!isLogIn" class="py-4 white--text" cols="12">
            <v-container>
                <v-row>
                    <v-col cols="12" md="3">
                        <h2 class="mb-1">Resources</h2>
                        <ul class="footer-ul">
                            <li v-for="(i, index) in items" :key="index">
                                <router-link to="/">{{i.text}}</router-link>
                            </li>
                        </ul>
                    </v-col>
                    <v-col cols="12" md="5">
                        <h2 class="mb-1">OffersOptimize</h2>
                        <p>OffersOptimize allows mobile Advertisers, Affiliates, Ad & Affiliate Networks, and Ad verification systems to view, monitor and validate online media activities through different devices and using mobile carriers worldwide.</p>
                    </v-col>
                    <v-col cols="12" md="4">
                        <h2 class="mb-1">Contact</h2>
                        <p>OFFICE ADDRESS: 2035 sunset lake road, suite b-2, Newark New Castle County, Delaware 19702</p>
                        <p>Email: support@offersoptimize.com</p>
                    </v-col>
                </v-row>
            </v-container>
        </v-col>
        <v-col class="pb-4 text-center white--text" cols="12">
            <v-divider class="mb-4"></v-divider>
            {{ new Date().getFullYear() }} — <strong>OffersOptimize</strong>
        </v-col>
    </v-row>
</v-footer>
</template>
<script>
export default {
    data:()=>({
        isLogIn: false,
        items: [
            { text: 'Blog'},
            { text: 'API Docs'},
            { text: 'Affilitest Alternative'},
            { text: 'Pricing'},
            { text: 'Terms of Service'},
            { text: 'Privacy Policy'},
            { text: 'Give Feedback'},
        ],
    }),
    methods: {
        checkOutLog(){
            if(localStorage.getItem('user')){
                this.isLogIn = true
            }else{
                this.isLogIn = false
            }
        }
    },
    mounted() {
        this.checkOutLog()
        this.$root.$on('LogChange', () => {
            this.checkOutLog()
        })
    },
}
</script>
<style scope>
    .footer-ul{
        list-style-type: none;
        padding: 0 !important;
    }
    .footer-ul li a{
        text-decoration: none;
        color: #fff
    }
    .footer-ul li a:hover{
        text-decoration:underline;
    }
</style>
